import { OnInit, Input, Component } from '@angular/core';
import { CropCycleInformationApiModel } from '../../models/cropCycleInformationApiModel';


@Component({
    selector: 'app-information-crop-cycle-header',
    templateUrl: './crop-cycle-header.component.html',
    styleUrls: ['./crop-cycle-header.component.scss'],
    standalone: false
})
export class CropCycleHeaderComponent implements OnInit {

  @Input() dataSourceLoaded: boolean;
  @Input() model: CropCycleInformationApiModel;
  ngOnInit() {
  }
}
